import CryptoJS from 'crypto-js';

const PASSWORD_CRYPT_KEY = '88444487';

export class CryptoUtil {
  private static readonly key = CryptoJS.enc.Utf8.parse(PASSWORD_CRYPT_KEY);

  /**
   * DES加密
   * @param message 需要加密的字符串
   */
  static encrypt(message: string): string {
    const keyHex = CryptoJS.enc.Utf8.parse(PASSWORD_CRYPT_KEY);
    const encrypted = CryptoJS.DES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString();
  }

  /**
   * DES解密
   * @param ciphertext 需要解密的字符串
   */
  static decrypt(ciphertext: string): string {
    try {
      const encryptedHexStr = CryptoJS.enc.Hex.parse(ciphertext);
      const encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
      const keyHex = CryptoJS.enc.Utf8.parse(PASSWORD_CRYPT_KEY);
      const decrypted = CryptoJS.DES.decrypt(encryptedBase64Str, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('Decryption failed:', error);
      return '';
    }
  }
}
